import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconForYou: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"for-you, for-me, event, address, post"} maskId="square-filled-radius-0-stroke-1-IconForYou"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM7 16H17V17H7V16ZM7 7V10H10V7H7Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconForYou;
